// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"f0d56d6a","453":"61524e86","549":"1ea8b2f6","741":"7259ec07","900":"7d033ce6","914":"cc1b15e1","954":"34f0716c"}[chunkId] + ".chunk.js";
};